import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import { REQUEST_CODES_FLOW, UPLOAD_CODES_FLOW } from '@app/constants';
import { setFooterConfig } from '@app/actions/footerActions';
import { connect } from 'react-redux';

import DefaultButton from '@components/buttons/default-btn/DefaultButton';
import './ApplyCodesFlowSelection.scss';

const ApplyCodesFlowSelection = ({ setFooterConfig, selectApplyCodesStep, navigateToCustomize }) => {
  const goToRequestCodes = () => selectApplyCodesStep(REQUEST_CODES_FLOW);
  const goToUploadCodes = () => selectApplyCodesStep(UPLOAD_CODES_FLOW);

  useEffect(() => {
    setFooterConfig({
      visible: true,
      onBack: navigateToCustomize,
      nextHidden: true,
    });
  }, [setFooterConfig]);

  return (
    <div id="qau-apply-codes-flow-selection">
      <div className="request-codes-container">
        <div className="request-codes-title">
          <LocalizedText id="qau-request-codes-option-title" />
        </div>
        <div className="request-codes-description">
          <LocalizedText id="qau-request-codes-description" />
        </div>
        <div className="request-codes-info-title">
          <LocalizedText id="qau-request-codes-info-title" />
        </div>
        <ol>
          {[
            'qau-request-codes-info-step-1',
            'qau-request-codes-info-step-2',
            'qau-request-codes-info-step-3',
          ].map((stepLocKey, index) => (
            <li key={stepLocKey} id={`info-list-item-${index}`}>
              <LocalizedText id={stepLocKey} />
            </li>
          ))}
        </ol>
        <DefaultButton className="request-codes-button" locKey="qau-request-codes-btn" onClick={goToRequestCodes} />
      </div>
      <div className="upload-codes-container">
        <div className="upload-codes-title">
          <LocalizedText id="qau-upload-codes-option-title" />
        </div>
        <div className="upload-codes-description">
          <LocalizedText id="qau-upload-codes-description" />
        </div>
        <DefaultButton className="upload-codes-button" locKey="qau-upload-codes-btn" onClick={goToUploadCodes} />
      </div>
    </div>
  );
};

ApplyCodesFlowSelection.propTypes = {
  setFooterConfig: PropTypes.func.isRequired,
  navigateToCustomize: PropTypes.func.isRequired,
  selectApplyCodesStep: PropTypes.func.isRequired,
};

export default connect(null, { setFooterConfig })(ApplyCodesFlowSelection);
